import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keyvalueOrder',
    pure: true,
})
export class KeyValueOrderPipe implements PipeTransform {
    transform<T>(
        value: Record<string, T>,
        order: string[],
    ): { key: string; value: T }[] {
        if (!value || typeof value !== 'object') {
            return [];
        }

        return Object.keys(value)
            .sort((a, b) => order.indexOf(a) - order.indexOf(b))
            .map((key) => ({ key, value: value[key] }));
    }
}
